import { render, staticRenderFns } from "./ProductEditTranslatedNames.vue?vue&type=template&id=db4d412e"
import script from "./ProductEditTranslatedNames.vue?vue&type=script&lang=ts"
export * from "./ProductEditTranslatedNames.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports